import { useEffect } from 'react';
import { setTitle } from '../utils/environment';

const BRAND = 'Read It Never';
const SEPARATOR = ' · ';

/**
 * Sets document.title to "<page> · Read It Never" (with [DEV] / [STAGING] env
 * prefix) for the lifetime of the calling component. Resets to the brand on
 * unmount so a subsequent page without this hook doesn't inherit a stale title.
 *
 * Pass `null` / falsy to skip the update (useful while page data is still loading).
 */
const useDocumentTitle = (page) => {
  useEffect(() => {
    if (!page) return;
    setTitle(`${page}${SEPARATOR}${BRAND}`);
    return () => {
      setTitle();
    };
  }, [page]);
};

export default useDocumentTitle;
